import {getAxios} from './axios'
import {addAuthTokenData} from './member';
import {responseResolveInterceptor} from 'backend-helpers/interceptors';

export function getProfileGuestbook(nick, offset) {
    let axios = getAxios();

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: '/profile/guestbook/',
        method: 'get',
        params: addAuthTokenData({nick, offset})
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/profileGuestbook.js